var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"title":_vm.title,"size":"md","backdrop":false},on:{"show":_vm.open,"hide":_vm.close},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}},[_vm._t("default"),_c('div',{attrs:{"slot":"footer"},slot:"footer"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }